import { useEffect } from 'react'

/**
 * Custom hook to dynamically update the document title
 * @param title - The title to set for the document
 */
export const useDocumentTitle = (title: string) => {
    useEffect(() => {
        if (!title) return

        // Update the document title
        document.title = title

    }, [title])
}